import { FC, Fragment, useReducer } from 'react';

import { Plus } from 'lucide-react';
import { toast } from 'sonner';
import { mutate } from 'swr';
import useSWRMutation from 'swr/mutation';

import Button from '@mui/material/Button';

import { CasinoFormDialog } from '../casinos/casinoFormDialog/CasinoFormDialog';
import { CasinoForm, initialValues } from '../casinos/casinoFormDialog/form';

import { casinoService } from 'v2/api/casinoService';
import { handleHttpError } from 'v2/utils';

export const CreateCasinoButton: FC = () => {
  const [isOpen, setOpen] = useReducer((state) => !state, false);

  const { trigger, isMutating } = useSWRMutation('createCasino', casinoService.createCasino, {
    onSuccess: () => {
      mutate('getCasinos');
      toast.success('Casino has been successfully created');
      setOpen();
    },
    onError: handleHttpError,
  });

  const handleSubmit = (values: CasinoForm, resetForm: VoidFunction) => {
    trigger(values).then(() => {
      resetForm();
    });
  };

  return (
    <Fragment>
      <Button onClick={setOpen} startIcon={<Plus />} variant="contained" size="large">
        Create Casino
      </Button>

      <CasinoFormDialog
        title="Create Casino"
        isOpen={isOpen}
        onClose={setOpen}
        initialValues={initialValues}
        isSubmitting={isMutating}
        onSubmit={handleSubmit}
      />
    </Fragment>
  );
};
